<template>
	<div id="wrapper">
		<SidebarView :cheque-processing="true" :transaction="true" :transVisible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="d-flex justify-content-between align-items-center">
								<div>
									<h6 class="m-0 fw-bold text-green">Cheque Processing</h6>
								</div>
								<div>
									<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
										<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
								</div>
							</div>
						</div>
						<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115);">
							<div class="home-box border border-success bg-white p-0">
								<div class="card-body pt-0">
									<form @submit.prevent="submitFormFilters()">
										<div class="row">
											<div class="col-12 col-md-4">
												<label class="akkurate-dark small" for="search">Search</label>
												<b-form-group id="search" label-for="search" class="akkurate-dark">
													<b-form-input id="search" class="mt-2 field-container fields" type="text" v-model="form.search" placeholder="Search by name, code, A/C, phone ...">
													</b-form-input>
												</b-form-group>
											</div>

											<div class="col">
												<label class="akkurate-dark small" for="product">Product</label>
												<b-form-group id="product" label-for="product" class="akkurate-dark">
													<multiselect v-model="form.product" :options="acc_types_option" :multiple="true" placeholder="Select Product" :close-on-select="false" label="name" :clear-on-select="false" class="mt-2 field-container" track-by="name">
														<template slot="selection">
															<span class="multiselect__single" v-if="form.product.length">{{ form.product.length }}
																options selected</span>
														</template>
													</multiselect>
												</b-form-group>
											</div>

											<div class="col">
												<label class="akkurate-dark small" for="transaction_type">User(s)</label>
												<multiselect class="mt-2 field-container" v-model="form.users" :options="users" placeholder="Select User" selectLabel="" :custom-label="fullName" :close-on-select="false" :clear-on-select="false" :multiple="true" deselectLabel="" :limit-text="limitText" :limit="1" track-by="id">
												</multiselect>
											</div>

											<div class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
												<b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100"><i class="fas fa-search me-2"></i>Search</b-button>
												<b-button size="sm" v-b-modal.modal-transaction title="show more filters" class="ms-2">
													<i class="fas fa-bars akkurate-small"></i>
												</b-button>
											</div>
										</div>
									</form>
								</div>
								<b-modal size="lg" id="modal-transaction" @ok="handleOk">
									<template #modal-title>
										<h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
									</template>

									<transaction-form :form="form" :users="users" :branch_option="branch_option"></transaction-form>

									<template #modal-footer="{ ok }">
										<div class="w-100">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button @click="$bvModal.hide('modal-transaction')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
												</span></b-button>
											<b-button @click="ok()" type="submit" :disabled="isSaving" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'search']" />Search</span></b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
						<div class="card-body pt-0 px-0">
							<div class="table_text_size">
								<!-- Go Through -->
								<b-table striped bordered responsive id="allChequeTable" :busy.sync="isLoading" :items="rows" :fields="trans_columns" :tbody-tr-class="rowClass" show-empty>
									<template #empty="scope">
										<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
									</template>
									<template #table-busy>
										<div class="text-center text-danger my-2">
											<b-spinner class="align-middle"></b-spinner>
											<strong>Loading...</strong>
										</div>
									</template>
									<template #cell(index)="data">
										{{ data.index + 1 }}
									</template>

									<!-- A custom formatted column -->
									<template #cell(user)="data">
										{{ data.item.created_user?.first_name }}
										{{ data.item.created_user?.surname }}
									</template>
									<template #cell(full_name)="data">
										{{ data.item.customer?.last_name }}
										{{ data.item.customer?.first_name }}
									</template>
									<template #cell(trans_status)="data">
										<span :class="statusBadge(data.item.trans_status)">{{ data.item.trans_status
										}}</span>
									</template>
									<template #cell(trans_amount)="data">
										{{ institution.currency_code }}
										{{
											displayNumber(
												data.item?.trans_amount
											)
										}}
									</template>
									<template #cell(reference)="data">
										<div>TRA{{ data.item?.id }}</div>
									</template>



									<template #cell(actions)="data">
										<span class="d-flex">
											<cheque-view :data="data.item" :user="users" :institution="institution" :bank_current_options="bank_current_options" @refreshCheque="filterTable()" />
											<!-- <a v-if="
												data.item.trans_status != 'REJECTED' &&
												data.item.trans_status != 'APPROVED' &&
												data.item.trans_status != 'COMPLETED' &&
												data.item.trans_status != 'REVERSED'
											" title="Approve" class="btn btn-sm akkurate-green-btn custom-pointer text-white"
												:href="`/journal/approve/${data.id}`">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'check',
												]" /></span>
											</a> -->
											<!-- <a title="Edit" class="btn btn-sm akkurate-blue text-white border-0" :href="`/journal/${data.id}/edit`">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'edit',
												]" /></span>
											</a> -->
											<reject :data="data.item" @rejected="rejected"></reject>
											<a v-if="data.item.status == 'APPROVED'" :disabled="isDisbursing" title="Clear" @click="disburseJournal(data.id)" class="btn btn-sm akkurate-gray-btn text-white custom-pointer">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'exchange-alt',
												]" /></span>
											</a>
											<a v-if="data.item.trans_status == 'COMPLETED'" :disabled="isReversing"
												title="Reverse" @click.prevent="reverseTransaction(data.item)" class="btn btn-sm akkurate-gray-btn text-white custom-pointer">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'arrow-rotate-left',
												]" /></span>
											</a>
										</span>
									</template>
								</b-table>
								<!-- End -->

								<div class="d-flex justify-content-between px-3 pb-3">
									<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="member-table"></b-pagination>
									<!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
									<div class="col text-end mt-1 akkurate-dark">
										<div>
											{{ currentPage }} - {{ perPage }} of
											{{ totalRecords }}
										</div>
										<b-form-group label="Per Page" label-size="sm" class="mb-0">
											<b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
										</b-form-group>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>

		<!-- <view-transaction-modal :showViewTransaction="showViewTransaction"></view-transaction-modal>
		<cash-deposit ref="showCashDeposit" :report_data="report_data"></cash-deposit>
		<cash-withdrawal ref="showCashWithdrawal" :report_data="report_data"></cash-withdrawal>
		<cheque-deposit ref="showChequeDeposit" :report_data="report_data"></cheque-deposit>
		<cheque-withdrawal ref="showChequeWithdrawal" :report_data="report_data"></cheque-withdrawal>
		<momo-deposit ref="showMomoDeposit" :report_data="report_data"></momo-deposit>
		<momo-withdrawal ref="showMomoWithdrawal" :report_data="report_data"></momo-withdrawal>
		<direct-debit-deposit ref="showDirectDebitDeposit" :report_data="report_data"></direct-debit-deposit>
		<direct-debit-withdrawal ref="showDirectDebitWithdrawal" :report_data="report_data"></direct-debit-withdrawal>
		<cheque-printout ref="showChequePrintout" :report_data="report_data"></cheque-printout>
		<cheque-template ref="showChequeTemplate" :report_data="report_data"></cheque-template> -->
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ApiService from "@/core/services/api.service";
import ChequeDeposit from "@/views/main/pages/transactions/reports/cheque/ChequeDeposit.vue";
import ChequeWithdrawal from "@/views/main/pages/transactions/reports/cheque/ChequeWithdrawal.vue";
import CashDeposit from "@/views/main/pages/transactions/reports/cash/CashDeposit.vue";
import CashWithdrawal from "@/views/main/pages/transactions/reports/cash/CashWithdrawal.vue";
import MomoDeposit from "@/views/main/pages/transactions/reports/momo/MomoDeposit.vue";
import MomoWithdrawal from "@/views/main/pages/transactions/reports/momo/MomoWithdrawal.vue";
import DirectDebitDeposit from "@/views/main/pages/transactions/reports/direct-debit/DirectDebitDeposit.vue";
import DirectDebitWithdrawal from "@/views/main/pages/transactions/reports/direct-debit/DirectDebitWithdrawal.vue";
import ChequePrintout from "../reports/printout/ChequePrintout.vue";
import ChequeTemplate from "../reports/printout/ChequeTemplate.vue";
import ExcelJS from "exceljs";
import Multiselect from "vue-multiselect";
import { hasPermission } from "@/helper";
import Reject from "../form/modal/Reject.vue";
import ChequeView from "../views/chequeView.vue";
import TransactionForm from "../all-deposit-withdrawal/form/TransactionForm.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		CashDeposit,
		CashWithdrawal,
		ChequeDeposit,
		ChequeWithdrawal,
		MomoDeposit,
		MomoWithdrawal,
		DirectDebitDeposit,
		DirectDebitWithdrawal,
		ChequePrintout,
		ChequeTemplate,
		Multiselect,
		Reject,
		ChequeView,
		TransactionForm,
		ChatBot,
	},
	data() {
		return {
			...this.initialState(),
			// code_option: [
			//   { name: "Customer code", value: "filter" },
			//   { name: "Account #", value: "account_number" },
			//   { name: "Ref.No", value: "code" },
			//   { name: "Mobile", value: "phone_number" },
			// ],
			user_pemissions: "",
			user_role: "",
			current_user_id: "",
			user_role: false,
			bank_current_options: [],
			trans_columns: [
				{
					label: "Account No",
					key: "account.account_number",
				},

				{
					label: "Member Name",
					//key: 'customer.first_name',
					key: 'full_name',
					// title: this.getFullname,
				},
				{
					label: "Amount",
					key: "trans_amount",
				},
				{
					label: "Cheque No",
					key: "cheque_number",
				},
				{
					label: "Product Type",
					key: "account.account_type.name",
				},
				{
					label: "Receipt Number",
					key: "reference",
				},
				{
					label: "Trans Type",
					key: "transaction_type",
				},
				{
					label: "Paying Date",
					key: 'trans_date',
					// key: this.getCreatedAt,
				},
				{
					label: "Status",
					key: "trans_status",
				},
				{
					label: "Mode",
					key: "transaction_mode",
				},
				// {
				// 	label: "Branch",
				// 	key: 'account.branch.name',
				// 	// key: this.getCreatedAt,
				// },
				// {
				// 	label: "Source",
				// 	key: "source",
				// },
				// {
				// 	label: "User",
				// 	key: "user",
				// },
				{
					label: "Actions",
					key: "actions",
					html: true,
					//   formatFn: this.renderActions,
				},
			],
			rows: [],
			isDisbursing: false,
			isReversing: false,
			currentPage: 1,
			perPage: 10,
			per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
			reverse_pemission: true,
			// serverParams: {
			//   columnFilters: {},
			//   sort: [
			//     {
			//       field: "", // example: 'name'
			//       type: "", // 'asc' or 'desc'
			//     },
			//   ],
			//   page: 1, // what page I want to show
			//   perPage: 20, // how many items I'm showing per page
			// },
		};
	},
	mounted() {
		this.getAccountDropdown();
		this.getInsistution();
		this.loadChequeTransactions();
		this.checkPemission();
	},
	methods: {
		statusBadge(item) {
			if (item === 'COMPLETED') {
				return 'badge akkurate-green-bg'
			} else if (item === 'FAILED') {
				return 'badge akkurate-danger-bg'
			} else if (item === 'REVERSED') {
				return 'badge akkurate-danger-bg'
			} else if (item === 'PENDING') {
				return 'badge akkurate-warning-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		rejected() {
			this.loadItems();
		},
		submitFormFilters() {
			//this.serverParams.page = 1;
			//currentPage
			// this.updateParams({ page: 1 });

			this.loadChequeTransactions();
			this.coa_name = this.form.users.map(index => {
				return `${index.first_name} ${index.surname}`;
			}).join(', ');
		},
		rowClass() {
			return 'custom-row-height'
		},
		filterTable() {
			this.loadChequeTransactions();
		},

		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.loadChequeTransactions();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadChequeTransactions();
		},
		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.submitFormFilters();
		},
		checkPemission() {
			// console.log(hasPermission())
			this.reverse_pemission = hasPermission(
				"transaction_management_deposit_withdrawal_reversal"
			);
			this.delete_trans = hasPermission(
				"transaction_management_delete"
			);
			this.restore_trans = hasPermission(
				"transaction_management_restore"
			);
		},

		refreshCheque() {
			console.log("HERE");
			this.loadChequeTransactions();
		},
		chequeApprovedAction() {
			this.loadChequeTransactions();
		},

		// onSortChange(params) {
		//   this.updateParams({
		//     sort: [
		//       {
		//         type: params.sortType,
		//         field: this.columns[params.columnIndex].field,
		//       },
		//     ],
		//   });
		//   this.loadChequeTransactions();
		// },

		// onColumnFilter(params) {
		//   // this.updateParams(params);
		//   this.loadChequeTransactions();
		// },
		async getAccountDropdown() {
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					// console.log(response);
					this.branch_option = response.data.branches;
					this.acc_types_option = response.data.account_types;
					this.users = response.data.users;
					this.bank_current_options = response.data?.bank_current;
				})
				.catch((error) => {
					// console.log(error);
				});
		},

		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		async loadChequeTransactions(searchFilter = null) {
			this.isLoading = true;
			var branch_id = [];
			var acc_id = "";
			var product_id = "";
			if (this.form.branch != []) {
				branch_id = this.form.branch.map((index) => index.id) ?? [];
			}
			if (this.form.acc_types != null) {
				acc_id = this.form.acc_types.id;
			}
			if (this.form.product != []) {
				product_id =
					this.form.product.map((index) => index.id) ?? [];
			}
			this.$Progress.start();
			this.isLoading = true;
			let source = "";
			if (this.form?.trans_source?.value === "ussd" || this.form?.trans_source?.value === "web" || this.form?.trans_source?.value === "mobile") {
				source = this.form?.trans_source.value;
			}

			await ApiService.post("/transactions/process/cheques", {
				"page": this.currentPage,
				"per_page": this.perPage,
				filter: this.form.search,
				branch_id: branch_id,
				account_type_id: acc_id,
				// account_number: ac,
				// mobile: phone,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				status: this.form.status,
				// code: code,
				transaction_type: this.form.transaction_type,
				external_reference: this.form.external_reference,
				source: source,
				users: this.form.users,
				product: product_id,
				term: this.form.term,
				transaction_mode: this.form.transaction_mode
			}).then((response) => {
				// console.log(response);
				this.rows = response.data.data;
				this.total_complete_deposits = response.data.total_complete_deposits
				this.total_complete_withdrawals = response.data.total_complete_withdrawals
				this.totalRecords = response.data.meta.total;
				// this.all_data = response.data.data;
				// this.rows.forEach(row => {
				// 	console.log(row.account.trans_status)
				// })

				this.$Progress.finish();
			})
				.catch((error) => {
					// console.log(error);
					this.isLoading = false;
					this.$Progress.fail();
				})
				.finally(() => {
					this.isLoading = false;
					this.$Progress.finish();
				});
		},

		initialState() {
			return {
				totalRecords: 0,
				showViewTransaction: false,
				searchFilter: "",
				total_complete_deposits: "",
				total_complete_withdrawals: "",
				delete_trans: false,
				restore_trans: false,
				coa_name: "",
				form: {
					branch: [],
					acc_types: "",
					start_date: "",
					end_date: "",
					status: "",
					// code: { name: "Customer code", value: "filter" },
					external_reference: "",
					users: [],
					status_option: [
						"Active",
						"Inactive",
						"Dormant",
						"Closed",
					],
					search: "",
					trans_source: {},
					transaction_type: "",
					product: [],
					term: "",
					transaction_mode: [],
				},
				branch_option: [],
				acc_types_option: [],
				isLoading: true,
				isSaving: false,
				add_or_edit: "add",
				report_data: {},
				institution: {},
				users: [],
			};
		},

		reverseTransaction(trans) {
			// Prevent multiple calls by checking if already processing
			if (this.isReversing) {
				return;
			}

			this.isReversing = true;

			swal.fire({
				title: "Reverse Transaction",
				text: `Are you sure you want to reverse transaction ${trans.code}?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
				allowOutsideClick: true,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white", // Custom class for the custom button
				},
			})
				.then((result) => {
					if (result.value) {
						let url = "/transactions/deposits/reverse";
						if (trans.transaction_type == "Deposit") {
							url = "/transactions/deposits/reverse";
						} else if (trans.transaction_type == "Withdrawal") {
							url = "/transactions/withdrawals/reverse";
						}

						this.$Progress.start();
						ApiService.post(url, {
							code: trans.code,
							source: "OFFICE",
						})
							.then((respp) => {
								this.$Progress.finish();
								toast.fire({
									icon: "success",
									title: respp.data.message,
								});
								this.loadChequeTransactions();
							})
							.catch((error) => {
								if (error.response?.data?.message) {
									toast.fire({
										icon: "error",
										title: error.response.data.message,
									});
								} else {
									toast.fire({
										icon: "error",
										title: "An error occurred",
									});
								}
								this.$Progress.fail();
							})
							.finally(() => {
								this.isReversing = false;
							});
					} else {
						this.isReversing = false;
					}
				})
				.catch((error) => {
					this.isReversing = false;
					console.log(error);
					toast.fire({
						icon: "error",
						title: "An error occurred",
					});
				});
		},

		viewTransaction(trans) {
			// console.log("Veeeew");
			this.showViewTransaction = true;
		},
		// getFullname(trans) {
		//   return `${trans.customer?.first_name} ${trans.customer?.last_name}`;
		// },
		getCreatedAt(trans) {
			return this.removeAfterDot(trans.created_at);
		},
		// approveWithdrawal(trans) {
		// 	swal.fire({
		// 		title: "Approve Withdrawal!",
		// 		// title: "Successfull Saved",
		// 		text: `Are you sure you want to approve withdrawal transaction ${trans.code}?`,
		// 		// text: 'CODE : 14345664565',
		// 		confirmButtonColor: "#018673",
		// 		icon: "info",
		// 		allowOutsideClick: false,
		// 		allowEscapeKey: false,
		// 		showCancelButton: true, // Show the "Cancel" button
		// 		confirmButtonText: "Yes", // Customize the text for the "OK" button
		// 		cancelButtonText: "No", // Text for the custom button
		// 		buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		// 		customClass: {confirmButton:"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
		// 			cancelButton:"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
		// 		},
		// 	}).then(async (result) => {
		// 		if (result.isConfirmed) {
		// 			await ApiService.post(
		// 				"/transactions/withdrawals/approve",
		// 				{
		// 					transaction_id: trans.id,
		// 					code: trans.code,
		// 				}
		// 			)
		// 				.then((respp) => {
		// 					toast.fire({
		// 						icon: "success",
		// 						title: respp.data.message,
		// 					});

		// 					this.loadChequeTransactions();
		// 				})
		// 				.catch((error) => {
		// 					if (error.response.data.message) {
		// 						toast.fire({
		// 							icon: "error",
		// 							title: error.response.data.message,
		// 						});
		// 					} else {
		// 						toast.fire({
		// 							icon: "error",
		// 							title: "An error occurred",
		// 						});
		// 					}
		// 				})
		// 				.finally((resp) => {
		// 					this.isLoading = false;
		// 				});
		// 		} else if (result.isDismissed) {
		// 		}
		// 	});
		// },
		removeAfterDot(inputString) {
			if (inputString.includes(".")) {
				return inputString.split(".")[0];
			}
			return inputString; // If there's no dot, return the original string
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`P${institutionDetailsRow}`).value = institutionName;
				ws.getCell(`P${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

				ws.getCell(`P${institutionDetailsRow + 1}`).value = institutionAddress;
				ws.getCell(`P${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

				ws.getCell(`P${institutionDetailsRow + 2}`).value = institutionMotto;
				ws.getCell(`P${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`P${institutionDetailsRow + 3}`).value = institutionPhone;
				ws.getCell(`P${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`P${institutionDetailsRow + 4}`).value = institutionEmail;
				ws.getCell(`P${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn('Q').width = 50;  // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Code",
					"References",
					"Full name",
					"Amount",
					"Account Number",
					"Transaction type",
					"Transaction mode",
					"Phone Number",
					"Status",
					"Date",
					"Source",
					"Users",
					"Product",
					"Old Code",
					"New Code"
				];



				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.rows.forEach(item => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.code,
						'TRA' + item.id,
						item.customer?.first_name + ' ' + item.customer?.last_name,
						item.trans_amount,
						item.account.account_number, // Remove extra spaces
						item.transaction_type,
						item.transaction_mode,
						item.customer.mobile,
						item.trans_status,
						item.trans_date,
						item.source,
						item.created_user?.first_name + ' ' + item.created_user?.surname,
						item.account.account_type?.name,
						item.customer.external_code,
						item.customer.code
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Exported_Transactions.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		rejectWithdrawal(data) {
			swal.fire(
				{
					title: "Confirm Withdrawal Rejection",
					// text: 'CODE : ' + response.data.transaction.code,
					text: "Are you sure you want to reject this withdrawal?",
					confirmButtonColor: "#018673",
					icon: "question",
					type: "input",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				},
				function (inputValue) {
					if (inputValue === null) return false;

					if (inputValue === "") {
						// swal.showInputError("You need to write something!");
						return false;
					}

					// swal("Nice!", "You wrote: " + inputValue, "success");
				}
			).then((result) => {
				// this.$Progress.start();
				if (result.isConfirmed) {
					this.isLoading = true;
					// this.getAccountStatement();
					// // this.isLoading = false;
					// this.$Progress.finish();

					this.loadChequeTransactions();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = false;
					// this.$Progress.finish();
				}
			});
		},
		printReceipt(data) {
			// console.log(data.item);
			this.report_data = {
				trans_date: data.trans_date,
				account_number: data.account?.account_number,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				transaction_mode: data.transaction_mode,
				transaction_type: data.transaction_type,
				amount: data.trans_amount,
				cheque_no: "not avaliable",
				bank_name: "not avaliable",
				branch_name: data.branch,
				narration: data.narration,
				institution: this.institution,
				receipt_no: data.id,
				teller:
					data.item?.created_user?.first_name +
					" " +
					data.item?.created_user?.surname,
				denomination: data.denominations,
				mobile: data.mobile,
				network: data.network,
				external_reference: data.external_reference,
				momo_reference: data.momo_reference,
			};
			switch (data.transaction_mode) {
				case "Cash":
					if (data.transaction_type == "Deposit") {
						this.$refs.showCashDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showCashWithdrawal.showModal();
					}

					break;
				case "Cheque":
					if (data.transaction_type == "Deposit") {
						this.$refs.showChequeDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showChequeWithdrawal.showModal();
					}
					break;
				case "Momo":
					if (data.transaction_type == "Deposit") {
						this.$refs.showMomoDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showMomoWithdrawal.showModal();
					}
					break;
				case "Direct Debit":
					if (data.transaction_type == "Deposit") {
						this.$refs.showDirectDebitDeposit.showModal();
						// console.log(this.form);
					} else if (data.transaction_type == "Withdrawal") {
						this.$refs.showDirectDebitWithdrawal.showModal();
					}
					break;
			}
		},
		chequePrintout(data) {
			this.report_data = {
				trans_date: data.trans_date,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				amount: data.trans_amount,
				institution: this.institution,
			};
			this.$refs.showChequePrintout.showModal();
		},
		chequeTemplate(data) {
			this.report_data = {
				trans_date: data.trans_date,
				fullname:
					data.customer?.first_name +
					" " +
					data.customer?.last_name,
				amount: data.trans_amount,
				// institution: this.institution,
			};
			this.$refs.showChequeTemplate.showModal();
		},
		fullName({ first_name, middle_name, surname, id, code }) {
			let name = "";
			if (first_name) {
				name = name + first_name;
			}
			if (middle_name) {
				name = name + " " + middle_name;
			}

			if (surname) {
				name = name + " " + surname;
			}

			return `${name} - ${id}`;
		},
		limitText(count) {
			return `and ${count} other user(s)`;
		},
		async disburseCheque(index) {
			this.isDisbursing = true;
			// console.log(this.form);
			swal.fire({
				// title: response.data.transaction.trans_status,
				title: "Disburse Amount",
				// text: 'CODE : ' + response.data.transaction.code,
				text: "Are you sure?",
				confirmButtonColor: "#018673",
				icon: "question",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.errors = "";
					this.isLoading = true;
					this.isDisbursing = false;
					this.$Progress.start();
					await ApiService.post(`/transactions/process/cheques/disburse/${index}`)
						.then((response) => {
							this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: response.data.message,
							});
							this.loadItems();
							// this.$bvModal.hide(String(this.loan_no + this.statement));
						})
						.catch((error) => {
							console.log(error.response.data.message);
							this.isDisbursing = false;
							this.isLoading = false;
							this.$Progress.fail();
							this.errors = error.response.data.message;
							// if (error.response.data.errors) {
							//     this.form.errors = error.response.data.errors;
							// }
						});
				} else if (result.isDismissed) {
					this.isDisbursing = false;
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
				}
			});
		},
		reverseCheque(index) {
			swal.fire({
				// title: response.data.transaction.trans_status,
				title: "Reverse Journal",
				// text: 'CODE : ' + response.data.transaction.code,
				text: "Are you sure?",
				confirmButtonColor: "#018673",
				icon: "question",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "No", // Customize the text for the "OK" button
				cancelButtonText: "Yes", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.isDisbursing = false;
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
				} else if (result.isDismissed) {
					this.isLoading = true;
					this.isDisbursing = false;
					this.$Progress.start();
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
					await ApiService.post(`/journals/reverse/${index}`)
						.then((response) => {
							// console.log(response);
							this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: response.data.message,
							});
							this.loadItems();
						})
						.catch((error) => {
							this.isDisbursing = false;
							this.isLoading = false;
							this.$Progress.fail();
							toast.fire({
								icon: "error",
								title: error.response.data.message,
							});
							// if (error.response.data.errors) {
							//     this.form.errors = error.response.data.errors;
							// }
						});
				}
			});
		},
		deleteTransaction(index) {
			swal.fire(
				{
					title: "Delete Transactions",
					// text: 'CODE : ' + response.data.transaction.code,
					text: "Are you sure you want to delete this Transaction?",
					confirmButtonColor: "#018673",
					icon: "question",
					type: "input",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true, // Show the "Cancel" button
					confirmButtonText: "Yes", // Customize the text for the "OK" button
					cancelButtonText: "No", // Text for the custom button
					buttonsStyling: false, // Disable SweetAlert2 styling for buttons
					customClass: {
						confirmButton:
							"btn btn-size btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
						cancelButton:
							"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
					},
				},
				function (inputValue) {
					if (inputValue === null) return false;

					if (inputValue === "") {
						// swal.showInputError("You need to write something!");
						return false;
					}

					// swal("Nice!", "You wrote: " + inputValue, "success");
				}
			).then(async (result) => {
				// this.$Progress.start();
				if (result.isConfirmed) {
					this.isLoading = true;
					await ApiService.delete(`/transactions/transaction/${index.id}`)
						.then((respp) => {
							toast.fire({
								icon: "success",
								title: respp.data.message,
							});
							this.loadChequeTransactions();
						}).catch((error) => {
							if (error.response.data.message) {
								toast.fire({
									icon: "error",
									title: error.response.data.message,
								});
							} else {
								toast.fire({
									icon: "error",
									title: "An error occurred",
								});
							}
						})
						.finally((resp) => {
							this.isLoading = false;
						});

					this.loadChequeTransactions();
					// this.$bvModal.hide(String(this.loan_no + this.statement));
				} else if (result.isDismissed) {
					this.isLoading = false;
					// this.$Progress.finish();
				}
			});
		},
		restoreTransaction(data) {
			swal.fire({
				title: "Please confirm",
				html: `Are you sure you want to <strong>RESTORE</strong> Transaction - <strong>${data.id}</strong>`,
				icon: "info",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Restore", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-gray-btn modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.post(
						`/transactions/transaction/${data.id}/restore`
					)
						.then((response) => {
							this.$Progress.finish();
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadChequeTransactions();
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
					//
				}
			});
		},
	},
	computed: {
		total_difference() {
			return (
				this.total_complete_deposits -
				this.total_complete_withdrawals
			);
		},
		getProduct() {
			if (this.form.product.length > 0) {
				const result = this.form.product.map((index) => {
					return index.name;
				});
				// console.log(result);
				return result.join(" | "); // Join array elements with ", "
			} else {
				return "";
			}
		},
	},
};
</script>